import { render } from "./ArrowNext.vue?vue&type=template&id=1f555b90&scoped=true&bindings={\"direction\":\"props\",\"buttonClicked\":\"options\"}"
import script from "./ArrowNext.vue?vue&type=script&lang=js"
export * from "./ArrowNext.vue?vue&type=script&lang=js"

import "./ArrowNext.vue?vue&type=style&index=0&id=1f555b90&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f555b90"

export default script